import { render, staticRenderFns } from "./AdventureMenu.vue?vue&type=template&id=21d7ae16&scoped=true&"
import script from "./AdventureMenu.vue?vue&type=script&lang=js&"
export * from "./AdventureMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdventureMenu.vue?vue&type=style&index=0&id=21d7ae16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7ae16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
